import React from 'react';
import { YogaDay2026 } from '../views';

const InternationalYogaDayPage = () => {
    return <YogaDay2026 />;
  };
  
  export default InternationalYogaDayPage; 